var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafetyComplianceMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 482 206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: #263238;\n      }\n\n      .cls-4 {\n        stroke: #010101;\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-2, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-width: .5px;\n      }\n\n      .cls-4, .cls-5, .cls-7 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4, .cls-5, .cls-8, .cls-9 {\n        fill: none;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-10, .cls-11 {\n        stroke: #050609;\n      }\n\n      .cls-6, .cls-8, .cls-2, .cls-9, .cls-10, .cls-11, .cls-13, .cls-3, .cls-12 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-6, .cls-14, .cls-13, .cls-12 {\n        fill: #fff;\n      }\n\n      .cls-15 {\n        opacity: .2;\n      }\n\n      .cls-7, .cls-16, .cls-11 {\n        fill: #050609;\n      }\n\n      .cls-2, .cls-9, .cls-13, .cls-3, .cls-12 {\n        stroke: #263238;\n      }\n\n      .cls-10, .cls-17 {\n        fill: #28a17f;\n      }\n\n      .cls-14 {\n        opacity: .6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "22.5 185.9 32.1 185.9 32.1 99.1 57.3 99.1 57.3 140.4 62.7 140.4 62.7 191.8 69 191.8 69 115.2 80.7 115.2 80.7 84.1 99.5 84.1 99.5 141.3 106.6 141.3 106.6 118.6 122.4 118.6 122.4 123.6 136 123.6 136 191.1 141.4 191.1 141.4 178.8 156.2 178.8 156.2 190.9 163.3 190.9 163.3 130 187.3 130 187.3 187.2 194.2 187.2 194.2 107.5 202.5 107.5 202.5 92.9 206.7 92.9 206.7 84.5 213.3 84.5 213.3 138.6 224.2 138.6 224.2 190.1 232.5 190.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 32.1,
    y: 96.4,
    width: 25.2,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 68.9,
    y: 115.2,
    width: 11.7,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 80.6,
    y: 84.1,
    width: 18.8,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 108,
    y: 115.7,
    width: 2.7,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 116.5,
    y: 116.9,
    width: 1.4,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 122.4,
    y: 123.6,
    width: 13.6,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 163.3,
    y: 128.8,
    width: 24,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 169.5,
    y: 126.3,
    width: 9.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "176.9 126.4 176.9 124.1 183.9 124.1 183.9 128.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "131.2 122.9 131.2 104.4 153.1 104.4 153.1 119.7 160.7 119.7 160.7 93.7 185 93.7 185 125.2 192.6 125.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "115.3 113.7 115.3 93.3 100.4 93.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "68.2 118.8 63.3 118.8 63.3 104.6 58.5 104.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "31.3 115 27.2 115 27.2 170.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "199.9 104.7 199.9 98.1 202 98.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "214.2 98.2 221.7 98.2 221.7 126.2 234.6 126.2 234.6 158.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 88,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 88,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 88,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 88,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 88,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 94.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 94.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 94.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 94.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 94.3,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 100.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 100.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 100.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 100.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 100.5,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 106.8,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 106.8,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 106.8,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 106.8,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 106.8,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 113,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 113,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 113,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 113,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 113,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 119.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 119.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 119.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 119.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 119.3,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.5,
    y: 119.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.9,
    y: 119.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.3,
    y: 119.3,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.5,
    y: 125.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.9,
    y: 125.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.3,
    y: 125.3,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.5,
    y: 131.4,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.9,
    y: 131.4,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.3,
    y: 131.4,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.5,
    y: 137.4,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.9,
    y: 137.4,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.3,
    y: 137.4,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.5,
    y: 143.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.9,
    y: 143.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.3,
    y: 143.5,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.5,
    y: 149.6,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.9,
    y: 149.6,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.3,
    y: 149.6,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.5,
    y: 155.7,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.9,
    y: 155.7,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.3,
    y: 155.7,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.5,
    y: 161.7,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.9,
    y: 161.7,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.3,
    y: 161.7,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.5,
    y: 167.8,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.9,
    y: 167.8,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.3,
    y: 167.8,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.5,
    y: 173.8,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.9,
    y: 173.8,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.3,
    y: 173.8,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.5,
    y: 179.9,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.9,
    y: 179.9,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.3,
    y: 179.9,
    width: 1.9,
    height: 3.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 100.8,
    y: 144.2,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 104.2,
    y: 144.2,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 100.8,
    y: 150.3,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 104.2,
    y: 150.3,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 100.8,
    y: 156.4,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 104.2,
    y: 156.4,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 100.8,
    y: 162.4,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 104.2,
    y: 162.4,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 100.8,
    y: 168.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 104.2,
    y: 168.5,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 100.8,
    y: 174.6,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 104.2,
    y: 174.6,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 100.8,
    y: 180.6,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 104.2,
    y: 180.6,
    width: 1.9,
    height: 3.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 125.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 125.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 125.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 125.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 125.5,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 131.7,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 131.7,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 131.7,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 131.7,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 131.7,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 138,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 138,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 138,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 138,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 138,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 144.2,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 144.2,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 144.2,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 144.2,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 144.2,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 150.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 150.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 150.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 150.5,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 150.5,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 156.7,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 156.7,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 156.7,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 156.7,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 156.7,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 163,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 163,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 163,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 163,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 163,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 169.2,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 169.2,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 169.2,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 169.2,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 169.2,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 175.4,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 175.4,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 175.4,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 175.4,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 175.4,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.1,
    y: 181.9,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.5,
    y: 181.9,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.9,
    y: 181.9,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.3,
    y: 181.9,
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.7,
    y: 181.9,
    width: 1.9,
    height: 3.7
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.7,
    y1: 116.5,
    x2: 80.7,
    y2: 191.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 109.5,
    y1: 120,
    x2: 109.5,
    y2: 190.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 113.2,
    y1: 120,
    x2: 113.2,
    y2: 190.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 116.9,
    y1: 120,
    x2: 116.9,
    y2: 190.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 120.6,
    y1: 120,
    x2: 120.6,
    y2: 190.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 124.3,
    y1: 127.1,
    x2: 124.3,
    y2: 190.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 128,
    y1: 127.1,
    x2: 128,
    y2: 190.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 131.7,
    y1: 127.1,
    x2: 131.7,
    y2: 190.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 103.2,
    x2: 56.1,
    y2: 103.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 107.8,
    x2: 56.1,
    y2: 107.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 112.3,
    x2: 56.1,
    y2: 112.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 116.9,
    x2: 56.1,
    y2: 116.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 121.4,
    x2: 56.1,
    y2: 121.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 126,
    x2: 56.1,
    y2: 126
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 130.6,
    x2: 56.1,
    y2: 130.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 135.2,
    x2: 56.1,
    y2: 135.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 139.7,
    x2: 56.1,
    y2: 139.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 144.3,
    x2: 56.1,
    y2: 144.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 148.9,
    x2: 56.1,
    y2: 148.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 153.5,
    x2: 56.1,
    y2: 153.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 158,
    x2: 56.1,
    y2: 158
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 162.6,
    x2: 56.1,
    y2: 162.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 167.2,
    x2: 56.1,
    y2: 167.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 171.7,
    x2: 56.1,
    y2: 171.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 176.3,
    x2: 56.1,
    y2: 176.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 180.9,
    x2: 56.1,
    y2: 180.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 185.5,
    x2: 56.1,
    y2: 185.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 190,
    x2: 56.1,
    y2: 190
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.1,
    y1: 194.6,
    x2: 56.1,
    y2: 194.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36,
    y1: 96.3,
    x2: 36,
    y2: 195.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.3 115.8 199.4 115.8 199.4 118.3 194.3 118.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "224 143.5 218.2 143.5 218.2 145.9 224 145.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "224 149.2 218.2 149.2 218.2 151.7 224 151.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "224 155 218.2 155 218.2 157.5 224 157.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "224 160.9 218.2 160.9 218.2 163.3 224 163.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "224 166.7 218.2 166.7 218.2 169.1 224 169.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "224 172.4 218.2 172.4 218.2 174.9 224 174.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "224 178.3 218.2 178.3 218.2 180.7 224 180.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "224 184.1 218.2 184.1 218.2 186.5 224 186.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.3 122.5 199.4 122.5 199.4 125 194.3 125"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.3 129.2 199.4 129.2 199.4 131.7 194.3 131.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.3 135.9 199.4 135.9 199.4 138.3 194.3 138.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.3 142.6 199.4 142.6 199.4 145 194.3 145"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.3 149.2 199.4 149.2 199.4 151.7 194.3 151.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.3 155.9 199.4 155.9 199.4 158.4 194.3 158.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.3 162.6 199.4 162.6 199.4 165.1 194.3 165.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.3 169.3 199.4 169.3 199.4 171.7 194.3 171.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.3 176 199.4 176 199.4 178.5 194.3 178.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 131.8,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 135.5,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 139.2,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 142.9,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 146.6,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 150.3,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 154,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 157.7,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 161.4,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 165.1,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 168.8,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 172.4,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 176.2,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 179.9,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 183.5,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 187.2,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.1,
    y: 190.9,
    width: 22.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 202.6,
    y1: 110,
    x2: 202.6,
    y2: 191.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 207.1,
    y1: 94.6,
    x2: 207.1,
    y2: 191.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 143.5,
    y: 173,
    width: 11.1,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 146.1,
    y: 162.8,
    width: 5.8,
    height: 10.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 99.5,
    y1: 141.3,
    x2: 99.5,
    y2: 191.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 163.1,
    y1: 135.8,
    x2: 136.2,
    y2: 135.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 163.1,
    y1: 138.8,
    x2: 136.2,
    y2: 138.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 137.4,
    y: 141,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 142.5,
    y: 141,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 147.5,
    y: 141,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 152.6,
    y: 141,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 157.6,
    y: 141,
    width: 4.1,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 137.4,
    y: 145.7,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 142.5,
    y: 145.7,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 147.5,
    y: 145.7,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 152.6,
    y: 145.7,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 157.6,
    y: 145.7,
    width: 4.1,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 137.4,
    y: 150.3,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 142.5,
    y: 150.3,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 147.5,
    y: 150.3,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 152.6,
    y: 150.3,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 157.6,
    y: 150.3,
    width: 4.1,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 137.4,
    y: 158.7,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 142.5,
    y: 158.7,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 147.5,
    y: 158.7,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 152.6,
    y: 158.7,
    width: 4.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 157.6,
    y: 158.7,
    width: 4.1,
    height: 3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 281.5,
    y: 36.5,
    width: 24.1,
    height: 130.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 299.7,
    y: 36.5,
    width: 20.4,
    height: 130.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 300.5,
    y: 37.9,
    width: 18.7,
    height: 6.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 303,
    y1: 38.8,
    x2: 303,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 305.8,
    y1: 38.8,
    x2: 305.8,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 308.5,
    y1: 38.8,
    x2: 308.5,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 311.3,
    y1: 38.8,
    x2: 311.3,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 314.1,
    y1: 38.8,
    x2: 314.1,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 316.8,
    y1: 38.8,
    x2: 316.8,
    y2: 43.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 282.6,
    y: 37.9,
    width: 16,
    height: 6.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 284.7,
    y1: 38.8,
    x2: 284.7,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 287.1,
    y1: 38.8,
    x2: 287.1,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 289.5,
    y1: 38.8,
    x2: 289.5,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 291.9,
    y1: 38.8,
    x2: 291.9,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 294.2,
    y1: 38.8,
    x2: 294.2,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 296.6,
    y1: 38.8,
    x2: 296.6,
    y2: 43.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 231.6,
    y: 53.6,
    width: 44,
    height: 113.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 234.3,
    y: 57.9,
    width: 16.3,
    height: 104.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 253,
    y: 53.6,
    width: 44,
    height: 113.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 256.6,
    y: 57.9,
    width: 36.8,
    height: 104.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 62.1,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 62.1,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 62.1,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 62.1,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 69.1,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 69.1,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 69.1,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 69.1,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 76.1,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 76.1,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 76.1,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 76.1,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 83.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 83.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 83.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 83.2,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 90.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 90.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 90.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 90.2,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 97.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 97.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 97.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 97.2,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 104.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 104.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 104.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 104.2,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 111.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 111.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 111.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 111.2,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 118.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 118.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 118.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 118.2,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 125.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 125.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 125.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 125.2,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 132.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 132.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 132.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 132.2,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 139.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 139.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 139.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 139.2,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 146.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 146.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 146.2,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 146.2,
    width: 7.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 258.3,
    y: 153.3,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 266.9,
    y: 153.3,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 275.5,
    y: 153.3,
    width: 7.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.1,
    y: 153.3,
    width: 7.5,
    height: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 62.1,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 62.1,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 62.1,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 62.1,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 69.1,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 69.1,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 69.1,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 69.1,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 76.1,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 76.1,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 76.1,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 76.1,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 83.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 83.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 83.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 83.2,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 90.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 90.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 90.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 90.2,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 97.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 97.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 97.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 97.2,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 104.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 104.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 104.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 104.2,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 111.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 111.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 111.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 111.2,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 118.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 118.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 118.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 118.2,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 125.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 125.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 125.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 125.2,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 132.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 132.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 132.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 132.2,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 139.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 139.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 139.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 139.2,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 146.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 146.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 146.2,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 146.2,
    width: 2.5,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 237,
    y: 153.3,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.9,
    y: 153.3,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 153.3,
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 245.7,
    y: 153.3,
    width: 2.5,
    height: 3.9
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 215.2,
    y: 177.4,
    width: 108.3,
    height: 15.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 264.9,
    y: 182.4,
    width: 2.8,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 252,
    y: 182.4,
    width: 2.8,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239,
    y: 182.4,
    width: 2.8,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 226.1,
    y: 182.4,
    width: 2.8,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 213.2,
    y: 182.4,
    width: 2.8,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 283.9,
    y: 182.4,
    width: 2.8,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 303,
    y: 182.4,
    width: 2.8,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 322,
    y: 182.4,
    width: 2.8,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 251.5,
    y: 155.5,
    width: 74,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 209.4,
    y: 155.5,
    width: 54.1,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 211.8,
    y: 160.4,
    width: 49.4,
    height: 16.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 265.4,
    y: 160.4,
    width: 10.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 277.4,
    y: 160.4,
    width: 10.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 289.5,
    y: 160.4,
    width: 10.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 301.5,
    y: 160.4,
    width: 10.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 313.5,
    y: 160.4,
    width: 10.3,
    height: 6.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 265.4,
    y: 170.6,
    width: 10.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 277.4,
    y: 170.6,
    width: 10.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 289.5,
    y: 170.6,
    width: 10.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 301.5,
    y: 170.6,
    width: 10.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 313.5,
    y: 170.6,
    width: 10.3,
    height: 6.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 212.3,
    y: 160.4,
    width: 8.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 222,
    y: 160.4,
    width: 8.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 231.7,
    y: 160.4,
    width: 8.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 241.4,
    y: 160.4,
    width: 8.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 251.1,
    y: 160.4,
    width: 8.3,
    height: 6.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 212.3,
    y: 170.6,
    width: 8.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 222,
    y: 170.6,
    width: 8.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 231.7,
    y: 170.6,
    width: 8.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 241.4,
    y: 170.6,
    width: 8.3,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 251.1,
    y: 170.6,
    width: 8.3,
    height: 6.4
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 230.9,
    y: 151.1,
    width: 43.5,
    height: 4.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 259.8,
    y: 151.1,
    width: 43.5,
    height: 4.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.7,31.9l-23.1,23.1c-2.1,2.1-5.5,2.1-7.6,0s-2.1-5.5,0-7.6l23.1-23.1c2.1-2.1,5.5-2.1,7.6,0s2.1,5.5,0,7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M344.7,55.7l-12.9,12.9c-1.2,1.2-3.2,1.2-4.4,0-1.2-1.2-1.2-3.2,0-4.4l12.9-12.9c1.2-1.2,3.2-1.2,4.4,0,1.2,1.2,1.2,3.2,0,4.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M294.2,66.4c-9.8,9.8-9.8,25.6,0,35.4,9.8,9.8,25.6,9.8,35.4,0,9.8-9.8,9.8-25.6,0-35.4-9.8-9.8-25.6-9.8-35.4,0ZM326.5,98.7c-8.1,8.1-21.1,8.1-29.2,0s-8.1-21.1,0-29.2,21.1-8.1,29.2,0c8.1,8.1,8.1,21.1,0,29.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 313,
    cy: 82.9,
    r: 20.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M295.3,65.2c-9.8,9.8-9.8,25.6,0,35.4,9.8,9.8,25.6,9.8,35.4,0,9.8-9.8,9.8-25.6,0-35.4s-25.6-9.8-35.4,0ZM327.6,97.5c-8.1,8.1-21.1,8.1-29.2,0-8.1-8.1-8.1-21.1,0-29.2,8.1-8.1,21.1-8.1,29.2,0s8.1,21.1,0,29.2Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 247.5,
    y1: 55.7,
    x2: 247.5,
    y2: 41.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M246.3,36.7v2.4l-.9,1.6c0,1.1.9,2,2,2h0c1.1,0,2-.9,2-2v-1.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 244.3,
    y: 32.2,
    width: 4,
    height: 4.4,
    transform: "translate(492.5 68.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.8,
    y: 26.3,
    width: 6.9,
    height: 8.9,
    transform: "translate(492.5 61.4) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 240.7,
    y: 30.7,
    width: 11,
    height: 2.7,
    transform: "translate(492.4 64.2) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "246.2 30.7 247.8 30.7 250 33.2 249.8 33.4 248.6 33.4 246.2 30.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "250.8 30.7 251.7 31.7 251.7 33.4 251.7 33.4 249.3 30.7 250.8 30.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "243.2 30.7 244.8 30.7 247 33.2 246.8 33.4 245.6 33.4 243.2 30.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "240.7 31.3 240.7 30.7 241.8 30.7 244 33.2 243.8 33.4 242.6 33.4 240.7 31.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 246.4,
    y1: 26.1,
    x2: 246.4,
    y2: 20.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "191.7 20.7 249.2 20.7 249.2 17.5 234.7 11.3 191.7 11.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "234.7 20.7 234.7 11.3 225.1 20.7 225.1 11.3 234.7 20.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "220.3 16 215.5 20.7 215.5 11.3 225.1 20.7 225.1 11.3 220.3 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "215.5 20.7 215.5 11.3 205.9 20.7 205.9 11.3 215.5 20.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "201.4 16.2 206 20.7 206 11.3 196.4 20.7 196.4 11.3 201.4 16.2"
  })))), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 247.2,
    y1: 48.9,
    x2: 212.1,
    y2: 75.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 247.2,
    y1: 48.9,
    x2: 282.3,
    y2: 75.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M281.7,75c-15.7-4.7-26.2-13-31.3-17.8-1.7-1.6-4.3-1.6-6,0-5.2,4.9-15.7,13.1-31.3,17.8-2,.6-3.3,2.5-3.1,4.6.8,9.5,5.7,35.8,34.6,61,1.7,1.4,4.1,1.4,5.8,0,28.8-25.2,33.8-51.5,34.6-61,.2-2.1-1.1-4-3.1-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M275.1,78.9c-12.1-3.8-20.4-10.1-24.8-14.1-1.7-1.5-4.3-1.5-5.9,0-4.3,4-12.6,10.3-24.8,14.1-2,.6-3.3,2.6-3.1,4.7.8,8.3,5.3,29.1,27.9,49.2,1.7,1.5,4.2,1.5,5.8,0,22.7-20,27.1-40.9,27.9-49.2.2-2.1-1.1-4-3.1-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M275.1,78.9c-9-2.8-15.9-7-20.7-10.6-2.9-2.2-7.1-.1-7.1,3.5v53.5c0,3.9,4.7,5.9,7.5,3.1,18.7-18.6,22.6-37.2,23.3-44.9.2-2.1-1.1-4-3.1-4.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 248,
    cy: 96.5,
    r: 9,
    transform: "translate(4.4 203.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M248.6,100c-.5,0-.9-.2-1.3-.6l-4-4.6c-.6-.7-.5-1.8.2-2.4.3-.3.7-.4,1.1-.4s1,.2,1.3.6l2.7,3.2,8.4-9.4c.3-.4.8-.6,1.2-.6s.8.2,1.1.4c.3.3.5.7.6,1.2,0,.4-.1.9-.4,1.2l-9.7,10.8c-.3.4-.8.6-1.2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M258.3,86.1c.3,0,.7.1.9.4.6.5.6,1.4.1,2l-9.7,10.8c-.3.3-.7.5-1.1.5h0c-.4,0-.8-.2-1.1-.5l-4-4.6c-.5-.6-.4-1.5.2-2,.3-.2.6-.3.9-.3s.8.2,1.1.5l2.9,3.4,8.6-9.6c.3-.3.7-.5,1.1-.5M258.3,85.6h0c-.5,0-1.1.2-1.4.6l-8.2,9.2-2.5-3c-.4-.4-.9-.7-1.5-.7s-.9.2-1.2.5c-.8.7-.9,1.9-.2,2.7l4,4.6c.4.4.9.7,1.4.7.6,0,1.1-.2,1.5-.6l9.7-10.8c.3-.4.5-.9.5-1.4,0-.5-.3-1-.6-1.3-.4-.3-.8-.5-1.3-.5h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M395.3,184.3s-2.3,3.5-4.1,4.9c-1.9,1.5-6.2,3.6-7.4,4.5s-.7,1.9-.3,2.3c.4.4,6,.7,9.1.7,3,0,8.6-1.3,8.6-1.3,0,0,2.4.4,3,0,.6-.3,1-1,1.1-2.1,0-1.1-.3-7.2-.3-7.2l-9.7-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M401.9,193.9c-2.4.4-2.8.9-7.4,1.6-3.8.6-9.4-.1-11.4-.5,0,.5.3.8.5,1.1.4.4,6,.7,9.1.7,3,0,8.6-1.3,8.6-1.3,0,0,2.4.4,3,0,.6-.3,1-1,1.1-2.1-.8,0-2,.1-3.4.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M397.3,186.9s-2.6-1.2-4.4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M394.3,185.9s2,1.6,1.8,3.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M395.4,188.7s-2.1-1-3.5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M393,187.9s1.6,1.3,1.4,2.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M393.8,190.6s-1.9-.9-4.9.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M391.4,189.8s1.1,1.1-.3,2.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M410.3,187.6s-1.1,4-1.5,4.6c-.4.6-3.1,3.9-3.1,5.1s.8,2.1,3,2.6c2.1.5,5.5.6,8.1-.5,2.6-1.2,3.8-1.6,4.5-3.4.7-1.8.2-8,.2-8,0,0-8.2-6.1-11.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M421.3,195.9c.2-.6.3-1.8.4-3.1-.5.7-1.1,1.7-1.9,2.5-1.3,1.4-3.5,3-7.8,3.4-3.1.2-5.2-1.1-6.1-1.9,0,.2-.1.4-.1.5,0,1.2.8,2.1,3,2.6,2.1.5,5.5.6,8.1-.5,2.6-1.2,3.8-1.6,4.5-3.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M416.1,186.3s-3.6-.2-4.7,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M412.2,186.3s3.1.7,3.6,2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M415.4,188.9s-3.6-.2-4.7,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M411.5,189s3.1.7,3.6,2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M414.7,191.5s-3.6-.2-4.7,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M410.8,191.6s3.1.7,3.6,2.1"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M388.8,108.6s1.4,20.9,2,26.8c.6,5.9,2,19.4,2.2,19.8.1.4.5,5.2.5,5.2,0,0-.4,1.9.1,6.1.5,4.2,1.9,12.9,1.9,12.9,0,0-1.2.2-1.1,1.2s.6,3.6.6,3.6c0,0,4.6,1.6,5.9,1.7,1.3.1,4,0,4,0,0,0,1.1-1.8,1-2.8-.1-1-1-3.5-1-3.5l.6-7.1,1-28.9s3.7,28.2,4.3,30.2c.6,2,1.2,5.3,1.2,5.3,0,0-1.2,1-1.2,1.6,0,.6.2,4.8.2,4.8,0,0,2.4-1.9,4.7-1.6,2.3.4,6,3,6,3,0,0,.2-2,.7-3.6.5-1.6-.5-5.5-.7-6.6s-.4-2.6-.1-3.7c.2-1.1.4-4.4.5-5.5.1-1.1-.1-27.9-.1-27.9l2.4-30.7-34.9-1.1-.6.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M394.1,63.4s-4.5,8.3-5.6,10.7-2.5,5.1-2.5,5.1c-4.2-6.1-8.5-12.3-13.1-18.2l-1-1.2s-5.7-2.2-6.3-1.6c-.5.5-1.8,8.6-.6,9.9,1.3,1.2,6.6,2,6.6,2l1,1h-.1c0,.1,8,18,9.3,19.2s2.8,3.4,5.6,3.5c1.6,0,7-11.4,7-11.4l-.3-19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M393.6,63.3l-6.9,12.1,5.4,13,3.4-6.9s1.9-18.9.5-19.1c-1.4-.2-2.4.9-2.4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M385,76.9s5.4,14.6,6.1,14.6,2.6-2.9,2.4-4.3c-.2-1.4-4.5-12.8-5.9-13-1.4-.2-1.9,1.3-2.6,2.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M375.1,63.7s-1.9-3.3-2.1-4.7c-.3-2.1,2.1-3.4,1-3.9-1.1-.5-3.2.9-3.4,2.5-.2,1.5.1,2.8.1,2.8,0,0-1.1,2-.8,3.4.3,1.5,1,3.1,1.6,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364.8,56.6s-1.3-.3-1.7,1.1c-.3.9,0,1.4.7,1.8s4.3,2.4,4.7,1.4c.4-1,.7-1.9,0-2.4s-3.7-1.9-3.7-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364.3,59.6s-1.3-.3-1.7,1.1c-.3.9,0,1.4.7,1.8.7.3,4.3,2.4,4.7,1.4.4-1,.7-1.9,0-2.4-.8-.5-3.7-1.9-3.7-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364,62.7s-1.1-.3-1.5.9c-.2.8,0,1.2.6,1.5.6.3,3.7,2.1,4,1.2.3-.9.6-1.6,0-2s-3.1-1.6-3.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364.1,65.5s-1-.3-1.3.8c-.2.7,0,1.1.5,1.3.5.2,3.3,1.8,3.6,1.1s.5-1.5,0-1.8c-.6-.3-2.8-1.4-2.8-1.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M401.5,57.1s-7.4,3.4-7.9,4.6c-.5,1.2-3,25.7-4.4,35.5-1.4,9.8-.8,12.4-.8,12.4,0,0,1.5,3.2,16.7,2.7,15.1-.5,20.5-2.8,20.7-4.1s.4.4.4-.6,1.1-44.6,0-47.3c-1.1-2.7-7.5-7.1-9.4-7.3-1.9-.2-15.2,4.1-15.2,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M389.2,98.7s0,0,0,.1c-.3,1.7-.4,3.2-.6,4.6,3.7.7,13,2.4,23.1,1.8,7.9-.5,12.3-.8,14.5-.9,0-1.3,0-2.9,0-4.6-5.3.5-25.8,2.4-37.1-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M414,77.5c.3-1.9,2.1-11.2,4.3-17.2l3.6,2.4h3.6c0,0-8.1-7-10.3-7.6-.3,0-.8,0-1.4,0-4.5,1.1-12.2,3.6-12.2,3.6,0,0-7.4,3.4-7.9,4.6,0,.2-.2.9-.4,2.1.5-.3,1.2-.7,1.9-1.1l-2.2,11.7c-.4,0-.7-.2-1.1-.3-.2,1.5-.4,3.1-.5,4.7,3.9.8,13,2.3,22.7,1.7,6.1-.4,10.1-.6,12.6-.8,0-1.5,0-3.1,0-4.6-2.9.3-7.5.6-12.6.7ZM395,76.4l2.7-13.6c3.4-1.9,7.4-4,9.1-4.5,3.3-1.1,6.5-1.3,6.5-1.3l1.9,1.3c-.2.6-4.3,11.1-5.4,19.2h.5c-5.3,0-10.8-.2-15.4-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M394.6,106.9c0,.9.1,1.8.2,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M396.9,86.5c-1.1,6.2-2.5,11-2.4,18.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M398.8,77.3s-.8,3.2-1.6,8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M390.6,109s-6.4-1-6.7-.2c-.4.7,0,10.5.6,11.1s4.7,1.4,5.9.7c1.2-.7,1.9-1.2,2.2-1.8s.2-8.1-.2-9.1c-.5-1-1.7-.7-1.7-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M398.1,110.2s-1,9.7.6,10.3c1.6.6,4.8.8,5.4.7s2.8-.5,3.1-1.4c.4-1,.4-8.5.1-9.2-.2-.7-8.6-1.3-9.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M413.2,111.3s.5,10.9.7,11.4c.2.5,4.8,3.5,5.6,3.4s7.5-.8,7.9-2.2c.4-1.3,1.2-12,.5-13.2s-2.3-1.7-3.7-1.8c-1.4-.1-9.8,1.1-9.8,1.1,0,0-1.1,0-1.2,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M404.6,54.3l-3.1,2.7v3.1c-.1,0-2.6,15.4-2.6,15.4,0,0,14.6-19,14.8-19.3.2-.3,3-1.7,3-1.7l-.9-3.8-1.5.4-9.7,3.2Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "401.5 57.1 403.6 61.1 403.9 58 405.7 62.4 411.6 57.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M402.6,32.1s-1.3,2.5-1.4,2.9c0,.4,0,1.5,0,1.5,0,0-3.3,3.3-3.2,3.6.1.2,1.4.7,1.4.7,0,0-1.2,8.5-.5,8.7.7.2,5.9-.3,5.9-.3l-.7,8.8,11-6.4,1.3-5.9s3.6-3.2,3.9-5.1c.3-1.9,0-2.3,0-2.3l-17.6-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M420.2,38.4l-11.3-4v.9c0,0-1.2,3.9-1.2,3.9,0,0,3.4-1.6,4.1-1.8.6-.2,1.4,2,.6,3.2-.9,1.1-3.3,2.4-3.3,2.4,0,0,2,2.9,4.4,3.5,1,.2,1.9.3,2.6.2l.2-.9s3.6-3.2,3.9-5.1c.3-1.9,0-2.3,0-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M401.9,34.9s1.1-.6,2.1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M402.7,37.1c0,.5-.3.8-.5.8-.2,0-.3-.5-.2-.9,0-.5.3-.8.5-.8.2,0,.3.5.2.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "398.7 49.3 407.2 49 404.6 51.5 404.7 49.2 398.7 49.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "413.3 38.3 416 46.7 418.3 45.2 415.6 38.5 413.3 38.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M401.4,30.1s-5.3-.2-4.7.1c.6.3,25.7,13,25.7,13,0,0-.2-2,0-2.6s1.9-4.6,2.2-8.9c.3-4.3-8.3-8.2-12.6-9.4-4.4-1.2-7,.6-7.8,2.8-.8,2.3-2.7,5-2.7,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M408.4,33.6l-4.4-2.5s3.8-5.7,3.8-6.5c0-.8.1-1.4.1-1.4,0,0,.3-1.2,4.3,0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M399,41.3s1.6-.5,2.6,0c1,.4,1.3,1.1,1.7,1.1.4,0,3-.6.3,1.1-1,.7-1.9.4-2.7.4-.8,0-1.8-.4-1.8-.4,0,0-1-.8-.2-2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M418.4,107.9s-1,1.1-2.2,1.7c0,0,.2.5-.4,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M441.1,82.3c-2.2-5.6-5.8-10.5-8.7-15.7-1-1.7-1.9-3.4-3.1-4.9-1.3-1.5-3-2.6-4.9-2.9,0,0,0,0,0,0-1.4-.1-2.9.3-3.9,1.3-1.1,1.1-1.5,2.2-1.7,3.7-.5,3.3.1,6.8,1.7,9.7,1.7,3.1,4.3,5.4,6.7,7.9.7.7,1.4,1.5,2.1,2.2-4.3,5.4-8.6,10.9-12.8,16.3-.3.3-.5.7-.7,1,0,0,0,0,0,0-.1,0-.2,0-.2,0l-3.6,2.1s-2.7,1.8-2.7,2.7c-.1,1.9.6,2.7,1.2,3.7,0,0,1.5,1.6,2.4,2.1.6.3,2,.9,2.9,0,.9-.8,3.7-1.6,3.9-2.8.2-1.2-1.2-1.1-1.2-1.1,0,0,1.3-.9,1.6-3,.4,0,.8-.2,1.2-.4,1.2-.6,2.3-1.5,3.4-2.4,4.8-4,9.9-7.5,14.7-11.4.9-.7,1.8-1.5,2.3-2.6.9-1.8.3-4-.5-5.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M441.1,82.3s-3.6-2.2-7.8-2.3c-2.7-.1-4.9.9-6.2,1.6-2.4-2.5-5.1-4.9-6.7-7.9-1.6-2.9-2.2-6.4-1.7-9.7.2-1.5.6-2.6,1.7-3.7,1-1,2.5-1.4,3.9-1.3,0,0,0,0,0,0,1.9.2,3.6,1.4,4.9,2.9,1.3,1.5,2.2,3.2,3.1,4.9,3,5.2,6.5,10.1,8.7,15.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M427.4,85.8s3.8-2.9,7.1-2.6c3.2.3,6.7,3,7.2,2.9.5-.2,1.9-1.6,1.4-3.2-.5-1.6-.6-2.6-1.4-4.3-.8-1.8-4.2-2.7-7.4-1.9-3.2.8-8.3,4.5-8.2,5.6s1.3,3.5,1.3,3.5Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyComplianceMonitoring);
export default __webpack_public_path__ + "static/media/safety-compliance-monitoring.d96d6b29657a4239c59a3fd1d5ae87e3.svg";
export { ForwardRef as ReactComponent };